import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'rk-share-title',
  template: `
    <div class="bloc" [class.center]="center">
      {{ title }}
    </div>
  `,
  styleUrls: ['./share-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareTitleComponent {
  @HostBinding('class.has-padding-top')
  @Input()
  hasPaddingTop = false;

  @Input()
  center = false;

  @Input()
  title = '';
}
